import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastProvider } from './context/ToastContext';

import LoginPage from "./pages/LoginPage";
import VerificationCodePage from "./pages/VerificationCodePage";
import ConfirmUser from "./pages/ConfirmUser";
import Scaffold from "./components/layout/Scaffold";
import Dashboard from "./pages/Dashboard";
import NewPayments from "./pages/NewPayments";
import MakePayment from "./pages/MakePayment";
import Invoices from "./pages/Invoices";
import History from "./pages/History";

function App() {
	return (
		<Router>
			<ToastProvider>
				<Routes>
					<Route path="/" element={<LoginPage />} />
					<Route path="/login" element={<LoginPage />} />
					<Route path="/login-verification" element={<VerificationCodePage />} />
					<Route path="/confirmuser/:salt" element={<ConfirmUser />} />
					<Route path="/*" element={<Scaffold />}>
						<Route path="dashboard">
							<Route index element={<Dashboard />} />
							<Route path="new-payment" element={<NewPayments />} />
							<Route path="payment-gateway" element={<MakePayment />} />
						</Route>
						<Route path="invoices">
							<Route index element={<Invoices />} />
						</Route>
						<Route path="history">
							<Route index element={<History />} />
						</Route>
					</Route>
				</Routes>
			</ToastProvider>
		</Router>
	)
}

export default App